import {createGlobalStyle} from 'styled-components';
import styledNormalize from 'styled-normalize';

import {useFeatures} from 'config/features';
import {FontFamily, FontWeight} from 'styles/Base';
import {Colors} from 'styles/Colors';
import headingDebuggingStyles from 'styles/HeadingDebugging';

const GeneratedStyles = createGlobalStyle<{enableHeadingDebugging: boolean}>`
${styledNormalize};


html {
  box-sizing: border-box;
}

*, *::before, *::after {
  box-sizing: inherit;
}

body {
  font-weight: ${FontWeight.REGULAR};
  font-family: ${FontFamily.DEFAULT};
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: ${Colors.NEAR_BLACK};
}

fieldset {
  margin: 0;
  padding: 0;
  border: none;
}

${headingDebuggingStyles}

`;

const GlobalStyles = () => {
  const {EnableHeadingDebugging} = useFeatures();
  return <GeneratedStyles enableHeadingDebugging={EnableHeadingDebugging} />;
};

export default GlobalStyles;
